import { Box } from '@mui/material';
import { PaginationTable, TableTitleBox } from '../../../common/components';
import FiltersBar from './components/FiltersBar';
import MetricsBoard from './components/MetricsBoard';
import NotificationsTable from './components/NotificationsTable';
import { useMobileNotificationsList } from './hooks/useMobileNotificationsList';

const MobileNotificationsList = () => {
  const {
    filters,
    page,
    rowsPerPage,
    notifications,
    totalPages,
    totalCount,
    metrics,
    isLoading,
    isFetching,
    handleFilterChange,
    handleResetFilters,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
  } = useMobileNotificationsList();

  return (
    <Box>
      <TableTitleBox title="Habitat 99 | Notificaciones mobile" />

      <MetricsBoard metrics={metrics} isLoading={isLoading && !notifications.length} />

      <FiltersBar
        filters={filters}
        onFilterChange={handleFilterChange}
        onSearch={handleSearch}
        onReset={handleResetFilters}
        disabled={isLoading}
      />

      <NotificationsTable
        notifications={notifications}
        isLoading={isLoading}
        isFetching={isFetching}
      />

      <PaginationTable
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </Box>
  );
};

export default MobileNotificationsList;
